module.exports = {"items":[{"name":"task_1","link":"01.docx"},{"name":"task_2","link":"02.docx"},{"name":"task_3","link":"03.docx"},{"name":"task_4","link":"04.docx"},{"name":"task_5","link":"05.docx"},{"name":"task_6","link":"06.docx"},{"name":"task_7","link":"07.docx"},{"name":"task_8","link":"08.docx"},{"name":"task_9","link":"09.docx"},{"name":"task_10","link":"10.docx"}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/tasks.json
// module id = Whuo
// module chunks = 1